export { RoundShapedPicturesWithDescription } from './RoundShapedPicturesWithDescription';
